import { render, staticRenderFns } from "./ProcessTimePerPhaseChart.vue?vue&type=template&id=06b280fc&scoped=true&"
import script from "./ProcessTimePerPhaseChart.vue?vue&type=script&lang=js&"
export * from "./ProcessTimePerPhaseChart.vue?vue&type=script&lang=js&"
import style0 from "./ProcessTimePerPhaseChart.vue?vue&type=style&index=0&id=06b280fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b280fc",
  null
  
)

export default component.exports